import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// Create the axios instance without the token in headers (we'll add it dynamically)
export const requestWithHeaders = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// Add an interceptor to dynamically set the Authorization header before each request
requestWithHeaders.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
